import React, { useMemo } from 'react'
import { Typography } from 'antd'
import produce from 'immer'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { StyledNoMarginFormItem } from '../../../core/components/styled'

import { ALL_TREE_SELECT_OPTION_NODE } from '../../constants'
import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormItemLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

import TreeSelect from './tree-select'

const FormTreeSelect = ({
  name,
  label,
  treeData,
  rules,
  labelAbove,
  showAllOption,
  treeCheckable,
  showColon,
  noStyle,
  ...rest
}) => {
  const treeDataWithAll = useMemo(
    () =>
      showAllOption && treeCheckable
        ? produce(treeData, newOptions => [
            {
              ...ALL_TREE_SELECT_OPTION_NODE,
              children: newOptions,
            },
          ])
        : treeData,
    [showAllOption, treeCheckable, treeData],
  )

  if (isNil(label)) {
    return (
      <StyledNoMarginFormItem name={name} rules={rules}>
        <TreeSelect
          name={name}
          treeData={treeDataWithAll}
          treeCheckable={treeCheckable}
          {...rest}
        />
      </StyledNoMarginFormItem>
    )
  }

  return (
    <StyledNoMarginFormItem
      labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
      name={name}
      label={
        <Typography.Text>
          {formatFormItemLabel(label, showColon)}
        </Typography.Text>
      }
      rules={rules}
      noStyle={noStyle}
    >
      <TreeSelect
        name={name}
        treeData={treeDataWithAll}
        treeCheckable={treeCheckable}
        {...rest}
      />
    </StyledNoMarginFormItem>
  )
}

FormTreeSelect.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  treeData: PropTypes.array.isRequired,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  labelAbove: PropTypes.bool,
  showAllOption: PropTypes.bool,
  treeCheckable: PropTypes.bool,
  showColon: PropTypes.bool,
  noStyle: PropTypes.bool,
}

FormTreeSelect.defaultProps = {
  label: undefined,
  noStyle: false,
  rules: undefined,
  labelAbove: false,
  showAllOption: false,
  treeCheckable: false,
  showColon: false,
}

export default FormTreeSelect
